import * as React from 'react'

import { Box, Table } from '@factorialco/deprecated-design-system'
import { WorkScheduleScheduleFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'

import TableBody from './Body'
import TableHeader from './Header'
import TitleBar from './TitleBar'

interface Props {
  schedule: WorkScheduleScheduleFragment
  archived?: boolean
  disabled?: boolean
  contractVersions: ContractVersions
}

const WorkScheduleTable = ({ schedule, archived, disabled = false, contractVersions }: Props) => {
  return (
    <Box width="full" overflowY="visible">
      <TitleBar
        archived={archived}
        schedule={schedule}
        disabled={disabled}
        contractVersions={contractVersions}
      />
      <Table fullWidth overflowY="auto" autoLayout noTopRadius>
        <TableHeader />
        <TableBody periods={schedule.overlapPeriods} />
      </Table>
    </Box>
  )
}

export default observer(WorkScheduleTable)
